/*引用vue和vuex*/
import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);

/*设置state参数*/
const state = {
  //页面头部显示
  showHeader: true,
  //菜单(默认数据)
  menuList: [],
  //控制遮罩层数据
  coverShow: false,
  //左边菜单显示隐藏
  contractNum: 1,
  //模型菜单位子
  process: 3,
  //PSprocess
  PSprocess: 2,
  CheckedValue: false,
  setSwitch: 1,
  location:1 // 初始值可以根据你的需求设置
};
// 操作数据
const mutations = {
  setShowHeader(state, str) {
    state.showHeader = str;
  },
  setMenuList(state, str) {
    state.menuList = str;
  },
  setCoverShow(state, str) {
    state.coverShow = str;
  },
  setContractNum(state, str) {
    state.contractNum = str;
  },
  setProcess(state, str) {
    state.process = str;
  },

  setPSprocess(state, str) {
    state.PSprocess = str;
  },
  setCheckedValue(state, newValue) {
    state.CheckedValue = newValue;
  },
  setLocation(state, location) {
        state.location = location;
    },
  setSwitch(state, str) {
    state.setSwitch = str;
  }
};
//
const getters = {
  showHeader: state => state.showHeader,
  menuList: state => state.menuList,
  coverShow: state => state.coverShow,
  contractNum: state => state.contractNum,
  process: state => state.process,
  PSprocess: state => state.PSprocess,
  CheckedValue: state => state.CheckedValue,
  location: state => state.location,
  setSwitch: state => state.setSwitch
};
//
const actions = {
  setShowHeader(context, payload) {
    context.commit("setShowHeader", payload);
  },
  setMenuList(context, payload) {
    context.commit("setMenuList", payload);
  },
  setCoverShow(context, payload) {
    context.commit("setCoverShow", payload);
  },
  setContractNum(context, payload) {
    context.commit("setContractNum", payload);
  },
  setProcess(context, payload) {
    context.commit("setProcess", payload);
  },
  setPSprocess(context, payload) {
    context.commit("setPSprocess", payload);
  },
  setSwitch(context, payload) {
    context.commit("setSwitch", payload);
  },
  setCheckedValue(context, newValue) {
    context.commit("setCheckedValue", newValue);
  },
  setLocation({ commit }, location) {
    commit("setLocation", location);
  }
};
const store = new Vuex.Store({
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions,
  plugins: [
    createPersistedState({
      storage: window.sessionStorage
      // reducer(val){
      //   return {
      //     assessmentData: val.assessmentData
      //   }
      // }
    })
  ]
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js